/* eslint-disable */
import React from "react";
import { Icon, IconVariants, IconSize } from "@next-platform/client-common-spicy-ui";
import { SpicyButton } from "@/components/customComponents";
import useAuth from "@/services/useAuth";

const BUTTON_TITLE = "Unlock Bot Creation";

const CreateCharacterLockedOverlay = (): React.JSX.Element => {
  const { register } = useAuth();
  return (
    <div className="text-center absolute bottom-0 w-screen left-1/2 -translate-x-1/2 bg-gradient-to-b from-[rgba(255,255,255,0.5)] dark:from-[rgba(0,0,0,1)] via-[rgba(157,178,206,0.5)] dark:via-[rgba(157,178,206,0.25)] to-[rgba(255,255,255,1)] dark:to-[rgba(0,0,0,1)] from-[0%] via-40% to-90% z-20 flex flex-col gap-5 justify-center items-center h-full box-border">
      <SpicyButton color="gradient_secondary" className="rounded-full h-20 w-20 p-8">
        <Icon icon={IconVariants.LOCK} size={IconSize.XLARGE} />
      </SpicyButton>
      <SpicyButton variant="secondary_large" color="gradient_primary_alt" className="w-[80%] sm:w-[300px] lg:mx-auto md:w-auto" onClick={register}>
        {BUTTON_TITLE}
      </SpicyButton>
    </div>
  );
};

export default CreateCharacterLockedOverlay;
